import styled from 'styled-components';
import { textTransform } from 'utils';

export const Title = styled.h3.attrs({
  className: 'b-ticket__title'
})`
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1.17;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.color.textPrimary};
  text-transform: ${textTransform};
`;

export const SubTitle = styled.p.attrs({
  className: 'b-ticket__sub-title'
})`
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 1.5px;
  text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.accent};
`;

export const Info = styled.p.attrs({
  className: 'b-ticket__info'
})`
  font-size: 1.6rem;
  line-height: 1.25;
  color: ${({ theme }) => theme.color.textPrimary};
`;

export const Time = styled(Info).attrs({
  className: 'b-ticket__time'
})`
  font-weight: 700;
  text-wrap: pretty;
`;
export const OperaSession = styled(Info).attrs({
  className: 'b-ticket__opera'
})`
display: flex;
align-items: start;
flex-direction:column;
  font-weight: 700;
  text-wrap: pretty;  
  font-size: 1.6rem;
  line-height: 1.33;
`;

export const TicketBox = styled.div.attrs({
  className: 'b-ticket'
})`
&.checkout_step {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  float: left;

  .b-ticket__ticket_info {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 21px;
    justify-content: flex-end;
    gap: 10px;
    
    .b-ticket__ticket_info_cotainer {
      margin-bottom: 33px;

      .b-ticket__title,
      .b-ticket__sub-title,
      .b-ticket__time,
      .b-ticket__info,
      .b-ticket__info ~ div {
        margin-left: 0;
      }
    }
  }

  .b-ticket__child_section {
    width: 100%;
  }
}
@media only screen and (max-width: 768px) { 
  &.checkout_step {
    float: none;
  }
}

@media only screen and (min-width: 768px) { 
  &.checkout_step {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .b-ticket__ticket_info {
      display: flex;
      flex-direction: column;
      margin-right: 21px;
      
      .b-ticket__ticket_info_cotainer {
        margin-bottom: 33px;

        .b-ticket__title,
        .b-ticket__sub-title,
        .b-ticket__time,
        .b-ticket__opera,
        .b-ticket__info,
        .b-ticket__info ~ div {
          margin-left: 0;
        }
      }
    }
  
    .b-ticket__child_section {
      width: 100%;
    }
  }
}

  ${SubTitle} {
    margin-top: 10px;
  }

  ${Time},
  ${Info} {
    margin-top: ${({ theme }) => theme.indent.s};
  }

  &._wide {
    &::after {
      content: '';
      display: table;
      clear: both;
    }

    .b-image-with-loader {
      float: left;
      width: 355px;
    }

    .b-ticket__title,
    .b-ticket__sub-title,
    .b-ticket__time,
    .b-ticket__opera,
    .b-ticket__info,
    .b-ticket__info ~ div {
      margin-left: calc(355px + ${({ theme }) => theme.indent.l});
    }

    .b-ticket__info + div {
      margin-top: 12px;
    }
  }

  &._compact {
    .b-image-with-loader {
      float: left;
      width: 96px;
      margin: ${({ theme }) => `0 ${theme.indent.m} ${theme.indent.m} 0`};
    }

    .b-ticket__title {
      margin-bottom: ${({ theme }) => theme.indent.m};
      font-size: 2rem;
    }

    .b-ticket__sub-title {
      margin-top: 0;
    }

    .b-ticket__info + div {
      clear: left;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    ._seatplan & {
      display: none;
    }

    &._wide {
      .b-image-with-loader {
        width: 315px;
        margin-bottom: ${({ theme }) => theme.indent.l};
      }

      .b-ticket__title,
      .b-ticket__sub-title,
      .b-ticket__time,
      .b-ticket__info,
      .b-ticket__opera,
      .b-ticket__info ~ div {
        margin-left: calc(315px + ${({ theme }) => theme.indent.m});
      }

      .b-ticket__info ~ .s-purchase__btn-next {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    &._wide {
      .b-image-with-loader {
        width: 150px;
        margin-bottom: ${({ theme }) => theme.indent.m};
      }

      .b-ticket__title,
      .b-ticket__sub-title,
      .b-ticket__time,
      .b-ticket__info {
        margin-left: calc(150px + ${({ theme }) => theme.indent.m});
      }

      .b-ticket__info ~ div {
        margin-left: 0;
      }

      .b-ticket__info + div {
        margin-top: ${({ theme }) => theme.indent.m};
        clear: left;
      }
    }
    
   &._compact {
    .b-ticket__title {
      margin-bottom: 10px;
      font-size: 1.8rem;
    }

    .b-ticket__sub-title {
      font-size: 1.5rem;
    }
  }
}

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.xs.width}) {
    &._wide {
      .b-image-with-loader {
        width: 80px;
      }

      .b-ticket__title,
      .b-ticket__sub-title,
      .b-ticket__time,
      .b-ticket__opera,
      .b-ticket__info {
        margin-left: calc(80px + 10px);
      }

      .b-ticket__title {
        font-size: 1.6rem;
      }

      .b-ticket__sub-title {
        font-size: 1.4rem;
      }

      .b-ticket__time,
      .b-ticket__info,
      .b-ticket__opera {
        margin-top: 4px;
        font-size: 1.4rem;
      }
    }

    &._compact {
      .b-image-with-loader {
        width: 80px;
        margin: ${({ theme }) => `0 ${theme.indent.s} ${theme.indent.m} 0`};
      }
  
      .b-ticket__title {
        margin-bottom: ${({ theme }) => theme.indent.s};
        font-size: 1.6rem;
      }
  
      .b-ticket__sub-title {
        font-size: 1.4rem;
      }
      
      .b-ticket__time,
      .b-ticket__info,
      .b-ticket__opera {
        font-size: 1.4rem;
      }
    }
  }
`;
